import React from 'react';
import { Button, Flex } from 'antd';
import { WizardNavigationProps } from '../types';

const WizardNavigation: React.FC<WizardNavigationProps> = ({
  currentStep,
  stepsCount,
  isSubmitting = false,
  submitButtonText,
  backButtonText,
  nextButtonText,
  onNext,
  onPrev,
  onSubmit,
  shouldDisableNext,
}) => {
  const isLastStep = currentStep === stepsCount - 1;
  const isFirstStep = currentStep === 0;
  const isNextDisabled = shouldDisableNext ? shouldDisableNext() : false;

  return (
    <Flex justify="space-between" style={{ marginTop: '24px' }}>
      {!isFirstStep && (
        <Button onClick={onPrev}>
          {backButtonText}
        </Button>
      )}

      {!isLastStep ? (
        <Button 
          type="primary" 
          onClick={onNext} 
          disabled={isNextDisabled}
          style={{ marginLeft: 'auto' }}
        >
          {nextButtonText}
        </Button>
      ) : (
        <Button 
          type="primary" 
          onClick={onSubmit} 
          loading={isSubmitting}
          style={{ marginLeft: 'auto' }}
        >
          {submitButtonText}
        </Button>
      )}
    </Flex>
  );
};

export default WizardNavigation;